<template>
    <div class="radio align-items-start"
         :class="{
        'radio-list':!inline,
        'radio-inline': inline
    }">
        <label v-for="(optionValue, optionTitle) in options" class="radio">
            <input type="radio"
                   :name="id"
                   :value="optionValue"
                   :checked="optionValue === value"
                   @change="$emit('input', optionValue)"
            >
            <span></span>
            <div v-html="optionTitle"/>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            types: [String, Number]
        },
        options: {
            types: [Array, Object],
            required: true
        },
        inline: Boolean
    },

    computed: {
        id() {
            return JSON.stringify(this.options)
        }
    }
}
</script>
